import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, Grid, Paper, Tab, Tabs, TextField } from '@material-ui/core';

import { financeApi as api } from 'api/finance';
import { DataTable, FormComponent, Notifications, TabPanel } from 'shared';
import dayjs from 'utils/dayjsConfig';

function DriverTipsDriverReport() {
    const [rows, setRows] = useState([]);
    const [reportIsReady, setReportIsReady] = useState(false);
    const [reportButtonText, setReportButtonText] = useState('Loading...');
    const [notification, setNotification] = useState({ text: '', level: '' });

    const [reportStartDate, setReportStartDate] = React.useState(dayjs().subtract(14, 'days').format('YYYY-MM-DD'));
    const handleReportStartDateChange = (event) => {
        setReportStartDate(event.target.value);
    };

    const [reportEndDate, setReportEndDate] = React.useState(dayjs().format('YYYY-MM-DD'));
    const handleReportEndDateChange = (event) => {
        setReportEndDate(event.target.value);
    };

    const handleRunReportClick = (event) => {
        getAndRenderReportData();
    };

    let getAndRenderReportData = async () => {
        setReportIsReady(false);

        setReportButtonText('Loading...');
        setRows([]);

        const response = await api.getDriverTipsDriverReport(reportStartDate, reportEndDate);

        if (response.status === false) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setReportButtonText('Run Report');
            setReportIsReady(true);
            return;
        }

        setRows(response.data.rows);
        setReportButtonText('Run Report');
        setReportIsReady(true);
    };

    useEffect(() => {
        getAndRenderReportData();
    }, []);

    const handleSyncPressed = async () => {
        setReportIsReady(false);
        setReportButtonText('Syncing Time Cards...');
        setRows([]);

        const response = await api.syncDriverTipsTimecards();

        if (response.status === false) {
            setNotification({ text: response.msg, level: 'error' });
        } else {
            setNotification({ text: 'Time cards synced', level: 'success' });
        }

        getAndRenderReportData();
    };

    const bulkActions = [];

    bulkActions.push({
        name: 'Delete',
        action: async (ids) => {
            if (window.confirm('Are you sure you want to delete?') === false) {
                return true;
            }

            const response = await api.deleteDriverTipsDriverRecords(ids);

            if (response.status === false) {
                setNotification({ text: `Unable to delete ${response.msg}`, level: 'error' });
                return false;
            }

            setNotification({ text: 'Records removed', level: 'success' });
            getAndRenderReportData();
            return true;
        },
    });

    const columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'costCenter', Header: 'Cost Center (Location)' },
        { accessor: 'date', Header: 'Date' },
        { accessor: 'driver', Header: 'Driver' },
        { accessor: 'employeeID', Header: 'Employee ID' },
        { accessor: 'hourlyRate', Header: 'Tip Rate / hour (P)' },
        { accessor: 'individualTipsEarned', Header: 'Tips Earned (I)' },
        { accessor: 'poolTipsEarned', Header: 'Tips Earned (P)' },
        { accessor: 'hoursWorked', Header: 'Hours worked' },
        { accessor: 'minutesWorked', Header: 'Minutes worked' },
        { accessor: 'payout', Header: 'Total Payout (P+I)' },
    ];

    return (
        <div>
            <Notifications options={notification} />
            <Grid item md={12} style={{ paddingRight: '35px' }}>
                <TextField
                    id="reportStartDate"
                    label="Start Date"
                    type="date"
                    value={reportStartDate}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    disabled={!reportIsReady}
                    onChange={handleReportStartDateChange}
                    style={{ marginRight: '50px' }}
                />

                <TextField
                    id="reportEndDate"
                    label="End Date"
                    type="date"
                    value={reportEndDate}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    disabled={!reportIsReady}
                    onChange={handleReportEndDateChange}
                    style={{ marginRight: '50px' }}
                />

                <Button id="runReport" onClick={handleRunReportClick} color="secondary" disabled={!reportIsReady}>
                    {reportButtonText}
                </Button>

                <Button id="syncTimeCards" onClick={handleSyncPressed} color="secondary" disabled={!reportIsReady}>
                    Sync Time Cards
                </Button>
            </Grid>
            <DataTable
                columns={columns}
                data={rows}
                csvExport
                csvExportFileName="driver-employee-report"
                csvExportHeadersUseAccessor
                selectMultiple
                bulkActions={bulkActions}
            />
        </div>
    );
}

export { DriverTipsDriverReport };
